import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';

export const COMPANY_QINETIC_PS_API_NAME: string = 'company_qinetic_ps';
export const COMPANY_QINETIC_PS_API_ENDPOINT: string = environment.API_BASE_PATH + '/company-qinetic-payment-source';

@Injectable({
  providedIn: 'root',
})
export class CompanyQineticPaymentSourceService {
  listCompanyQineticPaymentSources(company_id: string): Observable<any> {
    const api_name: string = COMPANY_QINETIC_PS_API_NAME;
    const path: string = `/company/${company_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }

  deleteCompanyQineticPaymentSource(company_id: string, cqps_id: string): Observable<any> {
    const api_name: string = COMPANY_QINETIC_PS_API_NAME;
    const path: string = `/${cqps_id}/company/${company_id}`;
    const init = { response: true };
    return from(API.del(api_name, path, init));
  }
}

export class CompanyQineticPaymentSource {
  company_qinetic_payment_source_id?: string;
  object?: string;
  company_id?: string;
  holder_fullname?: string;
  holder_email?: string;
  iban?: string;
  country?: string;
  is_default_source?: boolean;
}
